import Bloc from './Bloc.js';
import Types from './Types.js';

export default class StoreGlobalInteger extends Bloc {

	constructor (src, ctx) {

		super("writeintfvar", src, ctx, true);
		this.f = (src, ins) => {
			src.master.setVariable(ins[0], ins[1]);
			return [];
		};
		this.types = [Types.string, Types.int];
	}
}